export var DEFAULT_BASE_API_URL = 'https://api.sproutsocial.com';
export var USE_CASE_HEADER_KEY = 'X-Use-Case';
export var DEFAULT_USE_CASE_HEADER_VALUE = 'bi-connector-api-client';
export var ENDPOINTS = {
    CLIENT: function (baseUrl) { return "".concat(baseUrl, "/v1/metadata/client"); },
    CUSTOMER_PROFILES: function (baseUrl, customerId) { return "".concat(baseUrl, "/v1/").concat(customerId, "/metadata/customer"); },
    TAGS: function (baseUrl, customerId) { return "".concat(baseUrl, "/v1/").concat(customerId, "/metadata/customer/tags"); },
    GROUPS: function (baseUrl, customerId) { return "".concat(baseUrl, "/v1/").concat(customerId, "/metadata/customer/groups"); },
    ANALYTICS_PROFILE_METRICS: function (baseUrl, customerId) {
        return "".concat(baseUrl, "/v1/").concat(customerId, "/analytics/profiles");
    },
    ANALYTICS_POSTS: function (baseUrl, customerId) { return "".concat(baseUrl, "/v1/").concat(customerId, "/analytics/posts"); },
};
